<template>
  <transition name="fadePage"
              @enter="enter"
              @leave="leave"
              @enter-cancelled="enterCancelled"
              @leave-cancelled="leaveCancelled"
              @after-leave="complete"
              @after-enter="complete">
    <slot />
  </transition>
</template>


<script>
import { TweenMax, TimelineMax } from 'gsap';
import { isNil } from 'lodash';

export default {
  name: 'TransitionFadePage',
  css: false,


  props: {
    duration: {
      required: false,
      default: 0.25,
    },
  },

  methods: {
    enter: function (el, done) {
      done();
      // const tl = new TimelineMax({
      //   onComplete: done,
      //   onReverseComplete: done,
      // });
      // tl.add(TweenMax.fromTo(el, this.duration, { left: 0, opacity: 0 }, { left: 0, opacity: 1 }).delay(0.35));
    },
    enterCancelled: function (el) {
    },
    leave: function (el, done) {
      done();
    //   if (!isNil(el)) {
    //     const tl = new TimelineMax({
    //       onComplete: done,
    //       onReverseComplete: done,
    //     });
    //     tl.add(TweenMax.fromTo(el, this.duration, { left: 0, opacity: 1 }, { left: 0, opacity: 0 }));
    //   }
    },
    leaveCancelled: function (el) {
    },
    complete: function () {
      this.$emit('complete');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/transitions/TransitionFadePage.vue